import React, { Component } from "react";
import { Form, Input, Button, Icon, Checkbox, message } from "antd";
import Request from "srcDir/util/request";
import config from "projectRoot/config.json";
import Storage from "store2";
import BackImg from "srcDir/assets/images/home_page.jpg";
import Logo from "srcDir/assets/images/logo.png";
import "./style.scss";


const FormItem = Form.Item;

function hasErrors (fieldsError) {
  return Object
    .keys(fieldsError)
    .some(field => fieldsError[field]);
}

class index extends Component {
  constructor (props) {
    super(props);
    this.state = {
      logining: false
    };
  }

  componentDidMount () {
    this.props.form.validateFields();
  }

  handleSubmit (e) {
    e.preventDefault();
    this.props.form.validateFields((err, fields) => {
      if (!err) {
        this.setState({ logining: true });
        fields.vcode = "code";
        Request.POST(`${config.host}/login?method=platform-username-password-login`, {
          body: fields
        }, false, true).then(res => {
          if (res.success) {
            const token = res.data.token.access_token;
            const tokenBearer = "Bearer " + res.data.token.access_token;
            Storage.set("Authorization", token);
            Storage.set("AuthorizationBearer", tokenBearer);
            window.location.reload();
          } else {
            message.error(res.msg || "登录失败,请检查网络");
            this.setState({ logining: false });
          }
        });
      }
    });
  }

  render () {
    const { getFieldDecorator, isFieldTouched, getFieldError, getFieldsError } = this.props.form;
    const { logining } = this.state;

    const userNameError = isFieldTouched("userName") && getFieldError("userName");
    const passwordError = isFieldTouched("password") && getFieldError("password");
    return (
      <div style={{ background: `url(${BackImg}) repeat center center`, backgroundSize: "100% auto" }} className="login-wrap">
        <div className="login-box">
          <img src={Logo} alt="" />
          <Form onSubmit={(e) => this.handleSubmit(e)}>
            <FormItem
              validateStatus={userNameError ? "error" : ""}
              help={userNameError || ""}
            >
              {getFieldDecorator("username", {
                rules: [{ required: true, message: "请输入账号!" }],
              })(
                <Input prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />} placeholder="用户名/邮箱/手机号码" />
              )}
            </FormItem>
            <FormItem
              validateStatus={passwordError ? "error" : ""}
              help={passwordError || ""}
            >
              {getFieldDecorator("password", {
                rules: [{ required: true, message: "请输入密码!" }],
              })(
                <Input prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />} type="password" placeholder="密码" />
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator("remember", {
                valuePropName: "checked",
                initialValue: false,
              })(
                <Checkbox>记住我</Checkbox>
              )}
              <Button type="primary" htmlType="submit" className="login-btn" loading={logining} disabled={hasErrors(getFieldsError())}>
                登录
              </Button>
            </FormItem>
          </Form>
        </div>
      </div>
    );
  }
}

export default Form.create()(index);



// WEBPACK FOOTER //
// ./src/components/Login/index.js